"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoTitle = exports.ThumbnailContainer = exports.Media = exports.GalleryModalContent = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../../framework/ty"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var GalleryModalContent = _styledComponents["default"].div.withConfig({
  displayName: "Modalstyles__GalleryModalContent",
  componentId: "sc-2csti1-0"
})(["", ""], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["", ""])), function (_ref) {
  var _theme$gallery, _theme$gallery$modal;

  var theme = _ref.theme;
  return theme === null || theme === void 0 ? void 0 : (_theme$gallery = theme.gallery) === null || _theme$gallery === void 0 ? void 0 : (_theme$gallery$modal = _theme$gallery.modal) === null || _theme$gallery$modal === void 0 ? void 0 : _theme$gallery$modal.content;
}));

exports.GalleryModalContent = GalleryModalContent;

var Media = _styledComponents["default"].div.withConfig({
  displayName: "Modalstyles__Media",
  componentId: "sc-2csti1-1"
})(["", ""], (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["h-100 ", ""])), function (_ref2) {
  var _theme$gallery2, _theme$gallery2$modal;

  var theme = _ref2.theme;
  return theme === null || theme === void 0 ? void 0 : (_theme$gallery2 = theme.gallery) === null || _theme$gallery2 === void 0 ? void 0 : (_theme$gallery2$modal = _theme$gallery2.modal) === null || _theme$gallery2$modal === void 0 ? void 0 : _theme$gallery2$modal.media;
}));

exports.Media = Media;

var VideoTitle = _styledComponents["default"].div.withConfig({
  displayName: "Modalstyles__VideoTitle",
  componentId: "sc-2csti1-2"
})(["", ""], (0, _ty["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["", ""])), function (_ref3) {
  var _theme$gallery3, _theme$gallery3$modal;

  var theme = _ref3.theme;
  return theme === null || theme === void 0 ? void 0 : (_theme$gallery3 = theme.gallery) === null || _theme$gallery3 === void 0 ? void 0 : (_theme$gallery3$modal = _theme$gallery3.modal) === null || _theme$gallery3$modal === void 0 ? void 0 : _theme$gallery3$modal.videoTitle;
}));

exports.VideoTitle = VideoTitle;

var ThumbnailContainer = _styledComponents["default"].div.withConfig({
  displayName: "Modalstyles__ThumbnailContainer",
  componentId: "sc-2csti1-3"
})(["", ""], (0, _ty["default"])(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["h-100 ", ""])), function (_ref4) {
  var _theme$gallery$modal2, _theme$gallery$modal3;

  var theme = _ref4.theme;
  return theme === null || theme === void 0 ? void 0 : (_theme$gallery$modal2 = theme.gallery.modal) === null || _theme$gallery$modal2 === void 0 ? void 0 : (_theme$gallery$modal3 = _theme$gallery$modal2.thumbnail) === null || _theme$gallery$modal3 === void 0 ? void 0 : _theme$gallery$modal3.container;
}));

exports.ThumbnailContainer = ThumbnailContainer;